/*
 * Scott & Jamie — cart drawer helpers
 * 1. Countdown timer: starts when the bag has items, keeps running across pages (sessionStorage end time),
 *    restarts at 0, resets when the bag is emptied.
 * 2. Invalid discount code message: puts the typed code into the error text
 *    ("CODE" isn't a valid code. Please check and try again.). Horizon's cart-discount.js shows/hides it.
 */
(() => {
  const KEY = 'sj-cart-timer-end';

  const read = () => {
    try { return Number(sessionStorage.getItem(KEY)) || 0; } catch { return 0; }
  };
  const write = (v) => {
    try { if (v) sessionStorage.setItem(KEY, String(v)); else sessionStorage.removeItem(KEY); } catch { /* storage blocked */ }
  };

  function tick() {
    const drawer = document.querySelector('#cart-drawer .sj-drawer');
    if (!drawer) return;
    if (drawer.classList.contains('sj-drawer--empty')) { write(0); return; }
    const el = drawer.querySelector('[data-sj-timer]');
    if (!el) return;
    const minutes = Number(el.dataset.minutes) || 10;
    let end = read();
    const now = Date.now();
    if (!end || end <= now) { end = now + minutes * 60 * 1000; write(end); }
    const s = Math.ceil((end - now) / 1000);
    const text = `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
    if (el.textContent !== text) el.textContent = text;
  }
  tick();
  setInterval(tick, 1000);

  // Invalid code message with the typed code
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('cart-discount__form')) return;
    const input = form.querySelector('input[name="discount"]');
    const code = (input?.value || '').trim().toUpperCase();
    const msg = form.closest('cart-discount-component')?.querySelector('[data-sj-invalid-code]');
    if (msg && code) msg.textContent = `"${code}" isn't a valid code. Please check and try again.`;
  }, true);
})();
